// 'stepLabel' and 'stepTrackerLabel' are passed down to StepTracker
export default {
  en: {
    carouselLabel: '%{stepCount} items',
    iconButtonLabel: 'Show %{itemLabel} %{targetStep} of %{stepCount}',
    stepLabel: '%{itemLabel} %{stepNumber}',
    stepTrackerLabel: '%{itemLabel} %{stepNumber} of %{stepCount}',
    skipLink: 'Skip %{title}',
    playButtonLabel: 'Play',
    pauseButtonLabel: 'Pause'
  },
  fr: {
    // French translations
    carouselLabel: '%{stepCount} éléments',
    iconButtonLabel: 'Montrer %{itemLabel} %{targetStep} de %{stepCount}',
    stepLabel: '%{itemLabel} %{stepNumber}',
    stepTrackerLabel: '%{itemLabel} %{stepNumber} de %{stepCount}',
    skipLink: 'Passer %{title}',
    playButtonLabel: 'Lancer',
    pauseButtonLabel: 'Pauser'
  }
};